import React from 'react';
import { TextAreaInput, Tooltip } from 'components/common';

const TextAreaFormField = ({ config, value, setValue, register, errors, readOnly, disabled, setFetchInProgress }) => {

  const onChange = (e) => {
    setValue(config.name, e.target.value);
    if(config.publish_on_change_key != undefined) {
      var event = new CustomEvent(config.publish_on_change_key, { "detail": e.target.value });
      document.dispatchEvent(event);
    }
  }

  return (
    <tr>
      <td> {t(config.label)} { config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} /> }</td>
      <td align="right">
        <TextAreaInput
          name={config.name}
          placeholder={config.placeholder}
          register={register}
          errors={errors}
          class_name={config.class_name}
          validators={config.validators != undefined ? config.validators : []}
          value={value}
          cols={config.cols}
          rows={config.rows}
          onChange={onChange}
          readOnly={readOnly}
        />
      </td>
    </tr>
  )
}

export default TextAreaFormField;
